import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  snackbarSuccess: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `black !important`
  }
}));

const CustomSnackbar = props => {
  const classes = useStyles();
  const [open, setOpen] = useState(props.open);

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  return (
    <Snackbar open={open} onClose={props.onClose}>
      <Alert
        classes={{ filledSuccess: classes.snackbarSuccess }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={props.onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        severity={props.severity}
        variant="filled"
      >
        {props.message}
      </Alert>
    </Snackbar>
  );
};

CustomSnackbar.propTypes = {
  message: PropTypes.string.isRequired,
  severity: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

CustomSnackbar.defaultProps = {
  open: false
};

export default CustomSnackbar;
